<ui-card padding="sm" [elevated]="false">
  <section
    class="wishlist-detail-guest-guide"
    aria-labelledby="wishlist-detail-guest-guide-title"
  >
    <div class="wishlist-detail-guest-guide__header">
      <span class="wishlist-detail-guest-guide__icon" aria-hidden="true"
        >i</span
      >
      <h2 id="wishlist-detail-guest-guide-title">Jak działa rezerwacja?</h2>
    </div>

    <p>
      Wybierz prezent i zarezerwuj zakup, żeby inni wiedzieli, że planujesz go
      kupić.
    </p>

    <ol>
      <li>
        <span aria-hidden="true">1</span>
        Wybierasz prezent.
      </li>
      <li>
        <span aria-hidden="true">2</span>
        Podajesz email.
      </li>
      <li>
        <span aria-hidden="true">3</span>
        Klikasz link potwierdzający w mailu.
      </li>
      <li>
        <span aria-hidden="true">4</span>
        Inni zobaczą, że prezent jest zarezerwowany.
      </li>
    </ol>
  </section>
</ui-card>
